var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var DatastoreMissingModuleError = /** @class */ (function (_super) {
    __extends(DatastoreMissingModuleError, _super);
    function DatastoreMissingModuleError(collection) {
        return _super.call(this, "Missing collection \"" + collection + "\".\n        Check if you've imported Datastore" + collection
            .charAt(0)
            .toUpperCase() + collection.substr(1) + "Module in the parent module of any component that needs it.") || this;
    }
    return DatastoreMissingModuleError;
}(Error));
export { DatastoreMissingModuleError };
